module.exports = __webpack_public_path__ + "static/device_desktop_apple_dark-eb50a03ccb4de5ae53d9a64788459902.png";